"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NThresholdSystemVolumeConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NThresholdSystemVolumeConverter, _NotificationDocConve);

  function NThresholdSystemVolumeConverter() {
    _classCallCheck(this, NThresholdSystemVolumeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NThresholdSystemVolumeConverter).apply(this, arguments));
  }

  return NThresholdSystemVolumeConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NThresholdSystemVolumeConverter = NThresholdSystemVolumeConverter;